// extracted by mini-css-extract-plugin
export var hideEditor = "_f3-2";
export var infoIcon = "_f3-3";
export var label = "_f3-1";
export var labelContainer = "_f3-0";
export var readonlyText = "_f3-4";